import {
  HomeIcon,
  ChatBubbleBottomCenterTextIcon,
  CalendarDaysIcon,
  AcademicCapIcon,
  UserIcon,
  QuestionMarkCircleIcon,
  PlayIcon,
  TrophyIcon,
  SparklesIcon,
  UserGroupIcon
} from '@heroicons/react/24/outline'
import { GamerSection, SidebarBrand } from '../../../shared/types/navigation'
import { ComponentType } from 'react'

/**
 * Interface for gamer sidebar navigation items
 */
export interface GamerNavigationItem {
  id: GamerSection
  label: string
  icon: ComponentType<{ className?: string; style?: React.CSSProperties }>
  description?: string
  disabled?: boolean
  hideInSidebar?: boolean
  /** Hidden unless the One-on-One Coach is enabled for the user's organization. */
  requiresCoachEnabled?: boolean
  /** Shown only to a leader of the active organization. */
  requiresLeaderRole?: boolean
  /** Renders a product wordmark instead of the plain translated label. */
  brand?: SidebarBrand
}

/**
 * Navigation items for the gamer sidebar
 */
export const GAMER_NAVIGATION_ITEMS: GamerNavigationItem[] = [
  {
    id: GamerSection.MY_PEOPLE,
    label: 'gamer.navigation.myPeople',
    icon: UserGroupIcon,
    requiresLeaderRole: true
  },
  {
    id: GamerSection.DASHBOARD_GAMER,
    label: 'gamer.navigation.dashboard',
    icon: HomeIcon
  },
  {
    id: GamerSection.LATEST_SESSION_FEEDBACK,
    label: 'gamer.navigation.latestSessionFeedback',
    icon: ChatBubbleBottomCenterTextIcon
  },
  {
    id: GamerSection.UPCOMING_ACTIVITIES,
    label: 'gamer.navigation.upcomingActivities',
    icon: CalendarDaysIcon
  },
  {
    id: GamerSection.ONBOARDING,
    label: 'gamer.navigation.onboarding',
    icon: AcademicCapIcon
  },
  {
    id: GamerSection.ARIA_COACH,
    label: 'gamer.navigation.ariaCoach',
    icon: SparklesIcon,
    requiresCoachEnabled: true,
    brand: SidebarBrand.ARIA_COACH
  },
  {
    id: GamerSection.GAME_CENTER,
    label: 'gamer.navigation.gameCenter',
    icon: PlayIcon,
    hideInSidebar: true
  },
  {
    id: GamerSection.ACCOUNT_SETTINGS,
    label: 'gamer.navigation.accountSettings',
    icon: UserIcon,
    hideInSidebar: true
  },
  {
    id: GamerSection.MY_PROFILE,
    label: 'gamer.navigation.myProfile',
    icon: UserIcon
  },
  {
    id: GamerSection.FAQ,
    label: 'gamer.navigation.faq',
    icon: QuestionMarkCircleIcon
  },
  {
    id: GamerSection.DEEPER_TEAM_ANALYSIS,
    label: 'gamer.navigation.latestSessionFeedback',
    icon: ChatBubbleBottomCenterTextIcon,
    hideInSidebar: true
  },
  {
    id: GamerSection.DEEPER_INDIVIDUAL_ANALYSIS,
    label: 'gamer.navigation.latestSessionFeedback',
    icon: ChatBubbleBottomCenterTextIcon,
    hideInSidebar: true
  },
  {
    id: GamerSection.ACHIEVEMENTS,
    label: 'gamer.navigation.achievements',
    icon: TrophyIcon,
    hideInSidebar: true
  }
]
